import request from '@/utils/request.js'
import qs from 'qs';

/****换卡申请列表****/
export function getChangeCardList(data){
    return request({
        url: 'applyChangeSim/list',
        method: 'post',
        data
    })
}
export function getChangeCardListTui(data){
    return request({
        url: 'applyChangeSim/list/tui',
        method: 'post',
        data
    })
}
export function getChangeCardListTuiapp(data){
    return request({
        url: 'applyChangeSim/list/app',
        method: 'post',
        data
    })
}
export function getChangeCardListMy(data){
    return request({
        url: 'applyChangeSim/list/my',
        method: 'post',
        data
    })
}

export function getChangeCardListGrap(data){
    return request({
        url: 'applyChangeSim/list/grap',
        method: 'post',
        data
    })
}
/****处理换卡申请****/
export function dealWithChangeCard(data){
    return request({
        url: 'applyChangeSim/update',
        method: 'post',
        data
    })
}

export function dealWithChangeCardApp(data){
    return request({
        url: 'applyChangeSim/update/app',
        method: 'post',
        data
    })
}

export function dealWithChangeCardTui(data){
    return request({
        url: 'applyChangeSim/update/tui',
        method: 'post',
        data
    })
}
/****处理换卡申请****/
export function dealWithChangeCardMy(data){
    return request({
        url: 'applyChangeSim/update/my',
        method: 'post',
        data
    })
}
/****换卡申请列表****/
export function getChangeCardList1(data){
    return request({
        url: 'applyChangeSim/list/user',
        method: 'post',
        data
    })
}
/****换卡申请列表****/
export function getChangeCardList12(data){
    return request({
        url: 'applyChangeSim/list/user/agent',
        method: 'post',
        data
    })
}
/****处理换卡申请****/
export function dealWithChangeCard1(data){
    return request({
        url: 'applyChangeSim/update/user',
        method: 'post',
        data
    })
}


/****监控停机记录****/
export function getStopRecordList(data){
    return request({
        url: 'sim/polling/stopRecord',
        method: 'post',
        data
    })
}

/** 卡片导出 */
export function exportPollingStopInfo(data){
    return request({
        url: 'export/pollingStopList',
        method: 'post',
        data
    })
}

/** 退款申请列表信息导出 */
export function exportBackMoneyApplyInfo(data){
    return request({
        url: 'export/applyRefund',
        method: 'post',
        data
    })
}


/** 流量统计--根据时间查询流量范围 */
export function flowStatistics(data){
    return request({
        url: 'flow/sim/flow/query',
        method: 'post',
        data
    })
}

/** 流量统计---根据时间查询每日流量明细 */
export function flowEveryDayDetail(data){
    return request({
        url: 'flow/sim/flow/queryEveryDayFlow',
        method: 'post',
        data
    })
}

/** 流量统计---根据时间查询每月流量明细*/
export function flowEveryMonthDetail(data){
    return request({
        url: 'flow/sim/flow/query/month/detail',
        method: 'post',
        data
    })
}


/** 流量统计---导出*/
export function flowStatisticsExport(data){
    return request({
        url: 'export/queryEveryDayFlow',
        method: 'post',
        data
    })
}

/** 解绑实名申请*/
export function getCancelRealNameList(data) {
    return request({
        url: 'unbind/sim/list',
        method: 'post',
        data
    })
}

/**导入 */
export function CancelRealNameHandle(data) {
    return request({
        url: 'unbind/sim/batch/update',
        method: 'post',
        data
    })
}

/**编辑更新 */ 
export function CancelRealNameUpdate(data) {
    return request({
        url: 'unbind/sim/update',
        method: 'post',
        data
    })
}

/***获取运营商列表 */
export function supplierList(data) {
    return request({
        url: 'sim/supplier/list',
        method: 'post',
        data
    })
} 